module.exports = __webpack_public_path__ + "static/secondMovementFolkExample-b165ed6513035959e3e34175bf23106e.mp3";